import React from 'react';
import PropTypes from 'prop-types';
import './OrderSuccess.scss';

const OrderSuccess = ({ orderDetails }) => {
  const { medicineOrder, healthcareOrders } = orderDetails;
  return (
    <div className="OrderSuccessContainer">
      <div className="OrderSuccessTitle">Order Placed Successfully</div>
      <div style={{ display: 'flex' }}>
        {medicineOrder && <div className="OrderContainer">
          <div className="OrderTitle">Medicines:</div>
          <div className="OrderDetailsContainer">
            <div className="OrderImageContainer">
              <img src={require('../../images/order-icon.svg')} />
            </div>
            <div className="OrderDetailContainer">
              <div className="OrderDetailTitle">Order No.</div>
              <div className="OrderDetailValue">{medicineOrder.orderNumber}</div>
            </div>
            <div className="OrderDetailContainer">
              <div className="OrderDetailTitle">Estimated Delivery Date</div>
              <div className="OrderDetailValue">
                {`${medicineOrder.edd.eddDate || ''}${medicineOrder.edd.eddTime ? `, ${medicineOrder.edd.eddTime}` : ''}`}
              </div>
            </div>
          </div>
          <div className="tableHeader">
            <div className="tableHeaderTitle">Medicine Name</div>
            <div className="tableHeaderQty">Order Qty</div>
          </div>
          <div style={{ overflow: 'auto', maxHeight: '250px' }}>
          {medicineOrder.products.map((medicine) => (
            <div className="productContainer" key={medicine.productId}>
              <div className="productName">{medicine.name} {medicine.measurementUnit ? `(${medicine.measurementUnit})` : ''}</div>
              <div className="productQty">{medicine.quantity}</div>
            </div>)
          )}
          </div>
        </div>}
        {healthcareOrders && healthcareOrders.length > 0 && <div className="OrderContainer">
          <div className="OrderTitle">Health & Wellness Products:</div>
          {healthcareOrders.map((healthcareOrder) => <div className="healthcareOrderContainer">
            <div className="OrderDetailsContainer">
              <div className="OrderImageContainer">
                <img src={require('../../images/order-icon.svg')} />
              </div>
              <div className="OrderDetailContainer">
                <div className="OrderDetailTitle">Order No.</div>
                <div className="OrderDetailValue">{healthcareOrder.orderNumber}</div>
              </div>
              <div className="OrderDetailContainer">
                <div className="OrderDetailTitle">Estimated Delivery Date</div>
                <div className="OrderDetailValue">
                  {`${healthcareOrder.edd.eddDate || ''}${healthcareOrder.edd.eddTime ? `, ${healthcareOrder.edd.eddTime}` : ''}`}
                </div>
              </div>
            </div>
            <div className="tableHeader">
              <div className="tableHeaderTitle">Health & Wellness Products</div>
              <div className="tableHeaderQty">Order Qty</div>
            </div>
            {healthcareOrder.products.map((product) => (
              <div className="productContainer">
                <div className="productName">{product.name}</div>
                <div className="productQty">{product.quantity}</div>
              </div>)
            )}
          </div>)}
        </div>}
      </div>
    </div>
  );
};

export default OrderSuccess;

OrderSuccess.propTypes = {
  orderDetails: PropTypes.object.isRequired,
}
